import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { tryToUpdateEmail, tryToFetchMyAccountInfo, tryToResendVerificationEmail } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'

class UserSettingsEmailVerifiedForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.handleResendVerificationEmail = this.handleResendVerificationEmail.bind(this);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    if(!user.tryingToFetchMyAccountInfo){
      dispatch(tryToFetchMyAccountInfo());
    }
  }

  handleResendVerificationEmail(e){
    const { dispatch } = this.props;
    
    dispatch(tryToResendVerificationEmail());
    if(e) e.preventDefault();
  }


  render(){
    const { dispatch, user } = this.props; 

    if(user.email_verified){
      return <div>
        <span className="text-success text-700"><i className="fas fa-check"/> You're all set!</span>
        <br/>Thanks for verifying your email address.
      </div>
    }

    return <div>
      <div>
        <p className="text-warning text-700"><i className="fas fa-exclamation-triangle"/> Not yet verified!</p>
        <p>Please click the link in your email to verify <strong>{user.email}</strong></p>
        <p className="text-thin-line-height">
          <small>Until you verify your email, you will not be able to access all features unlocked with your account.</small></p>
      </div>
      <div className="flex-split">
        <span/>
        <Button 
          size="medium"
          thinking={user.tryingToResendVerificationEmail} 
          successful={user.successfullyResentVerificationEmail}
          failed={user.failedToResendVerificationEmail}
          color="white"
          display="Resend Link" 
          onClick={this.handleResendVerificationEmail}
        />
      </div>
    </div>
  }
}


// UserSettingsEmailVerifiedForm = reduxForm({
//   // a unique name for the form
//   form: 'UserSettingsEmailVerifiedForm',
//   enableReinitialize: true,
//   destroyOnUnmount: false
// })(UserSettingsEmailVerifiedForm)

// UserSettingsEmailVerifiedForm = connect((state, ownProps) => {
//   const { user } = state;

//   return {
//     user
//   }
// })(UserSettingsEmailVerifiedForm);

// export default UserSettingsEmailVerifiedForm;


const mapStateToProps = (state) => {      
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(UserSettingsEmailVerifiedForm);



// WEBPACK FOOTER //
// ./src/components/UserSettingsEmailVerifiedForm/UserSettingsEmailVerifiedForm.js